const facilityCounterDisplay = document.getElementById("filtered-count");
const facilityLabelDisplay = document.getElementById("facility-label");

function updateFacilityCounter(count) {
  if (facilityCounterDisplay && facilityLabelDisplay) {
    facilityCounterDisplay.innerHTML = count;
    facilityLabelDisplay.innerHTML = count === 1 ? "Facility" : "Facilities";
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const facilityElements = document.querySelectorAll(".facility-item");
  updateFacilityCounter(facilityElements?.length || 0);
});

if (document.getElementsByClassName("market-table")[0]) {
    // after location search
  document.addEventListener("seGeoSearch", (event) => {
    updateFacilityCounter(event.detail.count);
  });

  // after location feature filter
  document.addEventListener("seMarketFilter", (event) => {
    updateFacilityCounter(event.detail.count);
  });
}